module.exports = __webpack_public_path__ + "resources/0526136f10583f57bf74cc5f63f82529.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/typeless.png
// module id = 228
// module chunks = 0